import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ActivityTypeService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves the activity for the given no.
     *
     * @datatask 401
     * @datataskName sp_ws_p2_activitytype_get
     * @param params the activity type no.
     * @returns promise containing the activity type.
     */
    public async getActivityType(params: GetActivityTypeParams): Promise<ActivityTypeGet> {
        return (await this.datatask.Post(401, params))[0];
    }
}

export interface GetActivityTypeParams {
    activitytype_no: string | number;
}

export interface ActivityTypeGet {
    activitytype_no: string;
    activitytype_name: string;
    only_activityplan: '1' | '0';
    privat: '1' | '0';
    onweb: '1' | '0';
    show_solution_proposal: '1' | '0';
    show_solution_note: '1' | '0';
    show_prod_id: '1' | '0';
    show_cust_no: '1' | '0';
    show_project_keyno: '1' | '0';
    show_projectprosess_keyno: '1' | '0';
    show_actstatus_keyno: '1' | '0';
    show_equipment_id: '1' | '0';
    workorder: '1' | '0';
    show_solution_note_preventive: '1' | '0';
    show_datetime_start: '1' | '0';
    show_datetime_end: '1' | '0';
    show_responsible_user_id: '1' | '0';
    show_responsible_labour_no: '1' | '0';
    show_starttime_in_custact_relationlist: '1' | '0';
    is_activitytype_no_deviation: '1' | '0';
    is_activitytype_no_consignmentplan: '1' | '0';
    is_activitytype_no_consignmentassembly: '1' | '0';
    is_activitytype_no_voapproval: '1' | '0';
    show_actstatus_in_custact_relationlist: '1' | '0';
    is_jobcalc: '1' | '0';
    show_deadline: '1' | '0';
    show_next_activity: '1' | '0';
    is_sales_opportunity: '1' | '0';
    show_salarytype: '1' | '0';
    show_in_gantt: '1' | '0';
    show_guard: '1' | '0';
    show_serviceobject_keyno: '1' | '0';
    activitytype_prefix: string;
    confidential: '1' | '0';
    customer_invoice: '1' | '0';
    show_order_order_no: '1' | '0';
    show_custactproducts: '1' | '0';
    show_video_url: '1' | '0';
    sync_with_microsoft_365: '1' | '0';
}
